import { TrainingInsightFragment } from 'generated/resources/graphql'

export const useTrainingHoursAndCost = (insights: TrainingInsightFragment) => {
  const trainingHoursAndCost = insights.trainingsHoursAndCost
  const totalTrainings = trainingHoursAndCost?.totalTrainings || 0
  const totalCost = trainingHoursAndCost?.trainingCost || 0
  const salaryCost = trainingHoursAndCost?.salaryCost || 0
  const subsidizedCost = trainingHoursAndCost?.trainingSubsidizedCost || 0

  return { totalTrainings, totalCost, salaryCost, subsidizedCost }
}
